import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { StyleCatalogKey } from './style.i18n.js';
import { STYLE_CATALOG } from './style.i18n.js';

export type StyleMessageId = `style:${StyleCatalogKey}`;

const PREFIX_LENGTH = 'style:'.length;

/** `t()` for the stop-gap `style:` scope (see `style.i18n.ts`). */
export function useStyleT(): { t: (id: StyleMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: StyleMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as StyleCatalogKey;
      const raw = STYLE_CATALOG[locale][key] ?? STYLE_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
